import { useEffect, useState } from 'react';
import { Onboarding } from './components/Onboarding';
import { Dashboard } from './components/Dashboard';
import { useWalletStore } from './store/useWalletStore';

export function App() {
  const { walletId, initializeFromStorage } = useWalletStore();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    initializeFromStorage().finally(() => setReady(true));
  }, [initializeFromStorage]);

  if (!ready) return <div className="container py-10">Loading…</div>;

  return (
    <div className="container py-6">
      <header className="flex items-center justify-between py-4">
        <h1 className="text-xl font-semibold">DeviceBound Wallet</h1>
        <ThemeToggle />
      </header>
      {walletId ? <Dashboard /> : <Onboarding />}
    </div>
  );
}

function ThemeToggle() {
  const [dark, setDark] = useState(true);
  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add('dark'); else root.classList.remove('dark');
  }, [dark]);
  return (
    <button
      onClick={() => setDark(d => !d)}
      className="rounded border border-slate-700 px-3 py-1 text-sm hover:bg-slate-800"
    >
      {dark ? 'Light' : 'Dark'} mode
    </button>
  );
}


